/**
 * ForgotEmailPanel — split out of AuthHub.jsx in 2026-02.
 */
import { useState } from "react";

import { toast } from "sonner";
import { EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";
import { forgotPassword, formatUserApiError } from "../../lib/userApi";

import {
  GLASS, FieldLabel, TextInput, PasswordInput, DisplayField,
  GoldButton, GhostBackButton, useAuthShellBackground, parseCardDate,
} from "./_shared";

export default function ForgotEmailPanel({ onSent, onBack }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) return;
    setSubmitting(true);
    try {
      // The backend is enumeration-safe: it returns the same shape whether
      // the email exists or not. We always advance to the OTP screen.
      await forgotPassword(trimmed);
      toast.success("إن كان البريد مسجَّلاً، فقد أرسلنا إليه رمز الاستعادة.");
      onSent({ email: trimmed });
    } catch (err) {
      toast.error(formatUserApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <GhostBackButton onClick={onBack} testid="forgot-back-btn" />
      <section className={`${GLASS} p-5 sm:p-6`} data-testid="forgot-email-panel">
        <h1 className="text-[22px] font-extrabold text-[#0A192F] leading-tight">استعادة كلمة المرور</h1>
        <p className="text-[12.5px] text-[#5A6470] mt-1 mb-5">
          أدخِل بريدك الإلكتروني المسجَّل، وسنُرسل لك رمزاً من ستة أرقام لإعادة تعيين كلمة المرور.
        </p>
        <form onSubmit={onSubmit} className="space-y-3.5">
          <div>
            <FieldLabel>البريد الإلكتروني</FieldLabel>
            <TextInput
              data-testid="forgot-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              ltr
              placeholder="name@example.com"
              icon={EnvelopeSimple}
            />
          </div>
          <div className="pt-2">
            <GoldButton
              type="submit"
              disabled={submitting || !email.trim()}
              testid="forgot-submit"
            >
              {submitting ? "جارٍ الإرسال…" : (
                <><span>إرسال رمز الاستعادة</span><ArrowLeft size={18} weight="bold" /></>
              )}
            </GoldButton>
          </div>
        </form>
      </section>
    </>
  );
}

